import React, { useState, useEffect } from 'react';
import { Booking } from '../../pages';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { object, string, number, boolean } from 'yup';
import { BookingController } from '../../controllers';
import { bookingStore, userStore } from '../../stores';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';
import { CreateBooking, EditBooking } from '../../pages/Booking';

const CreateBookingContainer = ({
	setShowSurvey,
	closeModal,
	selectedLink,
	setEditLink,
	setViewBookings,
	setViewLinks,
	setCreateLinks,
	createLinks,
}) => {
	const [loading, setLoading] = useState(false);

	const { needFeedback } = useGetAllActiveReviews(
		constant.FEEDBACK.BOOKINGCREATE
	);

	const validationSchemaWithFreeBooking = () => {
		return object({
			title: string().required('Enter a Booking Link Name'),
			description: string().required('Enter the Booking Link description'),
			durationInMinutes: number(
				'enter the number minutes for each session'
			).required(),
			acceptPhoneNumber: boolean().required(
				'Should booking link require phone numbers?'
			),
			availableWeekends: boolean().required(
				'Do you accept bookings in the weekends?'
			),
			acceptPartPayment: boolean().required(
				'Should booking link accept part booking?'
			),
			currencyCode: string().required('Select Currency'),
			minDeposit: number('enter a number'),
		});
	};
	const validationSchemaWithoutFreeBooking = () => {
		return object({
			title: string().required('Enter a Booking Link Name'),
			description: string().required('Enter the Booking Link description'),
			durationInMinutes: number(
				'enter the number minutes for each session'
			).required(),
			acceptPhoneNumber: boolean().required(
				'Should booking link require phone numbers?'
			),
			availableWeekends: boolean().required(
				'Do you accept bookings in the weekends?'
			),
			acceptPartPayment: boolean().required(
				'Should booking link accept part booking?'
			),
			currencyCode: string().required('Select Currency'),
			chargeSplit: string().required('Select How you want to split charges'),
			minDeposit: number('enter a number'),
			amount: number('enter a number').required('Amount is required'),
		});
	};

	const goToViewLinks = () => {
		setViewLinks(true);
		setViewBookings(false);
		setCreateLinks(false);
		setEditLink(false);
	};

	const onSubmit = async values => {
		setLoading(true);
		let payload = {};
		payload = {
			...values,
		};

		delete payload.previewAmount;
		delete payload.previewFirstName;
		delete payload.previewLastName;
		delete payload.previewEmail;
		delete payload.previewMobile;
		delete payload.previewQuantity;

		if (payload.amount === '') {
			delete payload.amount;
		}

		if (payload.minDeposit === '') {
			delete payload.minDeposit;
		}

		if (createLinks) {
			for (const key in payload) {
				if (payload[key] === '') {
					delete payload[key];
				}
			}
			const { status, errorMessage } =
				await BookingController.createBookingLink(payload);

			if (status === constant.Success) {
				MimaToastUtil.success({
					message: constant.Success,
				});
				setLoading(false);
				goToViewLinks();
				if (needFeedback._id) {
					setShowSurvey(true);
					userStore.setReviewId(needFeedback._id);
				}
				return;
			} else {
				setLoading(false);
				MimaToastUtil.error({ message: errorMessage });
			}
		}
	};

	return (
		<CreateBooking
			validationSchemaWithFreeBooking={validationSchemaWithFreeBooking}
			validationSchemaWithoutFreeBooking={validationSchemaWithoutFreeBooking}
			onSubmit={onSubmit}
			loading={loading}
			closeModal={closeModal}
			createLinks={createLinks}
		/>
	);
};

export default CreateBookingContainer;
